import PhoneIcon from '@mui/icons-material/Phone'
import { SxProps, Theme } from '@mui/material'
import Button from '@mui/material/Button'
import { Call } from '@twilio/voice-sdk'
import { CallerType, CallStates } from 'api/models/Common/JyrneyEnums'
import { usePhoneDispatch, usePhoneState } from 'contexts/PhoneContext'
import * as React from 'react'

interface Props {
  id: string
  type: CallerType
  sx?: SxProps<Theme>
}

export const PhoneButton = (props: Props) => {
  const { id, type, sx } = props
  const [call, setCall] = React.useState<Call | undefined>()
  const { identity = 'defaultID', device } = usePhoneState()
  const dispatch = usePhoneDispatch()

  React.useEffect(() => {
    console.log('UE Register Twilio Call Event Listners')
    if (call) {
      console.log('UE Register Twilio Call Event Listners with Call ', call)
      call.on('accept', () => {
        console.log(
          `The incoming call was accepted or the outgoing call's media session has finished setting up.`,
        )
        console.log('callerInfo ', call.callerInfo)
        dispatch({
          type: 'setCallState',
          payload: CallStates.ON_CALL,
        })
      })
      call.on('cancel', () => {
        console.log('The call has been canceled.')
        dispatch({
          type: 'setCallState',
          payload: CallStates.READY,
        })
      })
      call.on('disconnect', () => {
        console.log('The call has been disconnected.')
        dispatch({
          type: 'setCallState',
          payload: CallStates.READY,
        })
      })
      call.on('error', (e) => {
        console.log('An error has occurred on call: ', e)
        dispatch({
          type: 'setCallState',
          payload: CallStates.READY,
        })
      })
      call.on('reconnected', () => {
        console.log('The call has regained connectivity.')
      })
      call.on('reconnecting', (twilioError) => {
        // update the UI to alert user that connectivity was lost eg callState?
        console.log('Connectivity error: ', twilioError)
      })
      call.on('reject', () => {
        console.log('The call was rejected.')
      })

      console.log('call.status ', call.status())
    }
  }, [call])

  if (!device) {
    return <></>
  }

  return (
    <Button
      startIcon={<PhoneIcon />}
      sx={[
        { margin: 0, padding: '6px 12px' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      onClick={async () => {
        console.log('Answer click')
        let call = await device?.connect({
          params: {
            id: `${id}`,
            type: type,
            identity: identity,
          },
        })

        setCall(call)
      }}
    >
      Call
    </Button>
  )
}

export default PhoneButton
